
import Vue from "vue";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { IDataTableColumn } from "winfakt-vue-components";
import {Script} from "@/models/script";
import {ScriptService} from "@/services/script-service";

export default Vue.extend({
	data(){
		return {
			scripts: [] as Script[],
			selectedRows: [] as Script[]
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		},
		value: {
			type: Object as ()=>Dossier,
			required: true
		},
	},
	computed: {
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "ID",
					width: "40px",
				},
				{
					name: "Name",
					property: "Name",
					width: "200px"
				},
				{
					name: "Created by",
					property: "CreatedBy",
					width: "200px"
				},
				{
					name: "Edited by",
					property: "LastEditedBy",
					width: "200px"
				}
			];
		},
		selectedItem():Script | null {
			if (this.selectedRows.length != 1) {
				return null;
			}
			return this.selectedRows[0];
		}
	},
	methods: {
		add(){
			this.$router.push(`/companies/${this.company.id}/dossier/${this.value.id}/scripts/new`);
		},
		edit(){
			if (!this.selectedItem) return;
			this.$router.push(`/companies/${this.company.id}/dossier/${this.value.id}/scripts/edit/${this.selectedItem.ID}`);
		},
		async remove(){
			let result = await this.$wf.confirm(`Are you sure you want to delete ${this.selectedRows.length} scripts`, "yes", "no");
			if (!result) return;
			for (let item of this.selectedRows){
				await ScriptService.deleteScript(this.value.id, item.ID);
			}
			this.selectedRows = [];
			this.fetch();
		},
		async fetch(){
			this.scripts = await ScriptService.getScripts(this.value.id);
		},
		compare(s1:Script, s2:Script):boolean{
			return s1.ID == s2.ID;
		}
	},
	mounted(){
		this.fetch();
	}
});
